import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../common/auth.service';
import {OtpService} from '../otp.service';
import {OtpErrorDefinition} from '../otp-error-defnition';

@Component({
  selector: 'otp-error',
  templateUrl: './error.component.html',
  styleUrls: ['error.component.scss'],
})
export class OtpErrorComponent implements OnInit {
  public error: OtpErrorDefinition;

  constructor(
    private authService: AuthService,
    public otpService: OtpService) {
  }

  public ngOnInit(): void {
  }

  public logout(): void {
    this.authService.logOut(true);
  }

}
